import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { companyService } from "../../services/company";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import UserForm from "../../components/forms/UserForm";
import { Toolbar } from "primereact/toolbar";
import ChangePasswordForm from "../../components/forms/ChangePasswordForm";

export default function UserSettings() {
  const [isDialogOpen, setDialogOpen] = useState(false);  
  const [passwordDialog, setPasswordDialog] = useState(false);
  
  const [selectedUser, setSelectedUser] = useState(null);
  const queryClient = useQueryClient();

  const { data: users, isLoading } = useQuery({
    queryKey: ["Users"],
    queryFn: () => companyService.getCurrentUsers(),
  });

  const mutation = useMutation({
    mutationFn: (userData) => {    
      return selectedUser
        ? companyService.updateUser(userData)
        : companyService.createUser(userData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["Users"] });
      toast.success(
        selectedUser ? "Kullanıcı güncellendi" : "Kullanıcı eklendi"
      );
      handleCloseDialog();
    }, 
    onError: () => {
      toast.error("Bir hata oluştu");
    },
  });
 const passwordMutation = useMutation({
    mutationFn: (userData) => {
     
      return  companyService.updateUserPassword(userData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["Users"] });
      toast.success(
     "Kullanıcı şifresi güncellendi"  
      );
      closePasswordDialog();
    },
    onError: () => {
      toast.error("Bir hata oluştu");
    },
  });
  const deleteMutation = useMutation({
    mutationFn: (userId) => companyService.deleteUser(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["Users"] });
      toast.success("Kullanıcı silindi");
    },
    onError: () => {
      toast.error("Kullanıcı silinirken bir hata oluştu");
    },
  });
  const openPasswordDialog = (user) => {
    setSelectedUser(user);

    setPasswordDialog(true);
  };  const closePasswordDialog = () => {
    setSelectedUser(null);
    setPasswordDialog(false);
  };

  const handleOpenDialog = (user) => {
    setSelectedUser(user);

    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setSelectedUser(null);
    setDialogOpen(false);
  };

  const handleDeleteConfirmation = (userId) => {
    confirmDialog({
      message: "Bu kullanıcıyı silmek istediğinizden emin misiniz?",
      header: "Kullanıcı Sil",
      icon: "pi pi-exclamation-triangle", acceptLabel: "Evet",
      rejectLabel: "Hayır",
      accept: () => deleteMutation.mutate(userId),
    });
  };
  const actionBodyTemplate = (rowData) => {
    return (
     <div className="flex gap-1">
       <React.Fragment>   <Button
                   icon="pi pi-key"
                   text
                   onClick={() => openPasswordDialog(rowData)}
                 />  
          <Button
                icon="pi pi-pencil" text
                onClick={() => handleOpenDialog(rowData)}
              />
              <Button text
                icon="pi pi-trash"
                className="p-button-danger"
                onClick={() => handleDeleteConfirmation(rowData.userId)}
              />
      </React.Fragment>
     </div>
    );
  };

  const statusBodyTemplate = (rowData)=>{
  
    return (
      <div>{rowData.status ? "Aktif":"Pasif"}</div>
    )
  }
  const footer = (
    <div>
      <span>Kullanıcı Sayısı: {users ? users.length : 0}</span>
    </div>
  );

  return (
    <div>
      <Toolbar className="shadow-3 border-round-md  my-2" 
        start={    <div className="text-2xl font-bold">Kullanıcı Ayarları</div>}
        end={
          <Button
            label="Yeni Kullanıcı"
            icon="pi pi-user-plus"
            onClick={() => handleOpenDialog()}
          />
        }
      />
      <DataTable  className="shadow-3 border-round-md table-content surface-ground"    scrollable scrollHeight="flex"
      
        value={users}
        loading={isLoading}
        footer={footer}
        emptyMessage="Liste Boş"
      >
        <Column field="userId" header="ID" />
        <Column field="fullName" header="Ad Soyad" />
        <Column field="email" header="Email" />
        <Column field="address" header="Adres" />
        <Column field="mobilePhones" header="Telefon" />
        <Column field="notes" header="Not" />
        <Column field="status" header="Durum" body={statusBodyTemplate} />
        <Column
          header="İşlemler"
          alignHeader= "center"
          align= "center"
          headerStyle= {{ width: "4rem", textAlign: "center"} }
          bodyStyle= { {textAlign: "center", overflow: "visible"} }
          body= {actionBodyTemplate}   
        />
      </DataTable>
      <UserForm
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
        onSubmit={(data) => mutation.mutate(data)}
        initialData={selectedUser}
      />
      <ConfirmDialog />
       <ChangePasswordForm
              isOpen={passwordDialog}
              onClose={closePasswordDialog}
              onSubmit={(data) => passwordMutation.mutate(data)}
              initialData={selectedUser} 
            />
    </div>
  );
}
